import { ChangeDetectionStrategy, Component, ViewEncapsulation } from "@angular/core";
import { ModalComponent } from "../../modal/modal.component";
import { S25CheckboxModule } from "../../s25-checkbox/s25.checkbox.module";
import { ModalHeaderComponent } from "../../modal/modal.header.component";
import { S25ButtonComponent } from "../../../standalone/s25.button.component";

@Component({
    standalone: true,
    template: `
        <s25-modal-header [data]="params()"></s25-modal-header>
        <div class="modal-body">
            <div class="grid">
                @for (occ of data.occs; track occ) {
                    <s25-ng-shift-selectable-checkbox
                        [(value)]="occ.included"
                        [index]="$index"
                        [group]="'se-select-occurrences'"
                    >
                        {{ occ.label }}
                    </s25-ng-shift-selectable-checkbox>
                }
            </div>
        </div>
        <div class="modal-footer">
            <s25-ng-button [type]="'primary'" (clicked)="params()?.closeModal(true)"> Continue </s25-ng-button>
            <s25-ng-button [type]="'outline'" (clicked)="params()?.closeModal(false)"> Cancel </s25-ng-button>
        </div>
    `,
    styles: ``,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [S25CheckboxModule, ModalHeaderComponent, S25ButtonComponent],
})
export class SeRegisterOccurrencesModal extends ModalComponent<{
    occs: { id: number; label: string; included: boolean }[];
}> {}
